export { PLUGIN_KEY, PLUGIN_PRIORITY, DropdownMenu } from "./dropdownMenu.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/dropdownMenu/index.mjs
// module id = 1350
// module chunks = 1